import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-line', 'IconChartLine', [
  ['path', { d: 'M4 19l16 0', key: 'svg-0' }],
  ['path', { d: 'M4 15l4 -6l4 2l4 -5l4 4', key: 'svg-1' }],
]);
